import React from "react";
import "./RCServices.css";
import { useNavigate } from "react-router-dom";
import { FcServices } from "react-icons/fc";

import rcImg from "../assets/rcimg.jpg";
import mobImg from "../assets/mob.jpg";
import rcDetailImg from "../assets/rcdetail.jpg";
import basicImg from "../assets/basic.png";
import chassisImg from "../assets/chassis.png";
import pucImg from "../assets/pucc.png"

const services = [
  { name: "Owner RC PDF", img: rcImg, path: "/dashboard/rcpdf" },
   { name: "RC PDF Server 2", img: rcImg, path: "/dashboard/rcpdf2" },
  { name: "RC Registered Mobile No.", img: mobImg, path: "/dashboard/RctoMobile" },
  { name: "RC Particulars", img: rcDetailImg, path: "/dashboard/rcdetails" },
  { name: "RC Pro", img: rcDetailImg, path: "/dashboard/rcpro" },
   { name: "RC ADVANCE", img: rcDetailImg, path: "/dashboard/rcadvance" },
    { name: "Find Father From RC", img: rcDetailImg, path: "/dashboard/rcfather" },
  { name: "RC BASIC", img: basicImg, path: "/dashboard/rcbasic" },
  { name: "Chassis to Vehicle Number", img: chassisImg, path: "/dashboard/chassis-to-rc" },
  { name: "Vehicle PUC PDF", img: pucImg, path: "/dashboard/puc-apply" }
];

export default function RCServices() {
  const navigate = useNavigate();

  return (
    <div className="rc-services-wrapper">
<h2 className="rc-title">
  <FcServices className="rc-icon" /> All RC Related Services
</h2>
      <div className="rc-divider"></div>

      <div className="rc-services-box">

        {services.map((item, i) => (
          <div className="service-card" key={i}>
            <div className="circle-box" onClick={() => navigate(item.path)}>
              <img src={item.img} alt={item.name} draggable="false" />
            </div>
            <p className="service-name">{item.name}</p>
          </div>
        ))}

      </div>
    </div>
  );
}
